import Vue from "vue";
import Router from "vue-router";
import { TokenService } from "../services";
import {store} from '../store'

Vue.use(Router);

const AsyncDashboard = () =>
  import(/*webpackChunkName: "Dashboard" */ "@/views/Dashboard");
const AsyncLoginView = () =>
  import(/*webpackChunkName: "Login" */ "@/views/Login");
const AsyncRegisterView = () =>
  import(/*webpackChunkName: "Register" */ "@/views/Register");
const AsyncPrincipalView = () =>
  import(/*webpackChunkName: "Principal" */ "@/views/Principal");
const AsyncPageNotFound = () =>
  import(/*webpackChunkName: "PageNotFound" */ "@/views/PageNotFound");
const AsyncSaleOrder = () =>
   import(/*webpackChunkName: "SaleOrder" */ "@/views/SaleOrder");
const AsyncSalePerson = () =>
   import(/*webpackChunkName: "SalePerson" */ "@/views/SalePerson");
const AsyncInventory = () =>
  import(/*webpackChunkName: "Inventory" */ "@/views/Inventory");
const AsyncInventoryReports = () =>
  import(/*webpackChunkName: "Inventory" */ "@/views/InvReports");
const AsyncReasonCategory = () =>
  import(/*webpackChunkName: "reasonCategory" */ "@/views/IvReasonCategory");
const AsyncUserManagement = () =>
  import(/*webpackChunkName: "UserManagement" */ "@/views/UserManagement");
const AsyncPageBuildingView = () =>
  import(/*webpackChunkName: "PageBuilding" */ "@/views/PageBuilding");
const AsyncCustomerManagement = () =>
  import(/*webpackChunkName: "CustomerManagement*/ "@/views/CustomerManagement");
const AsyncPurchaseManagement = () =>
  import (/*webpackChunkName: "PurchaseManagement" */"@/views/PurchaseManagement")
const AsyncAdmRateExchange = () =>
  import (/*webpackChunkName: "AdmRateExchange" */"@/views/AdmRateExchange")
const AsyncPaymentMethod = () =>
  import (/*webpackChunkName: "AdmPaymentMethod" */"@/views/AdmPaymentMethod")
const AsyncInvTransferEntry = () =>
  import (/*webpackChunkName: "InvTransfEntry" */"@/views/InvTransferEntry")
const AsyncInvAdjustmentEntry = () =>
  import (/*webpackChunkName: "InvAdjustmentEntry" */"@/views/InvAdjustmentEntry")
const AsyncAdmTaxMaster = () =>
  import (/*webpackChunkName: "AsyncTaxMaster" */"@/views/AdmTaxMaster")
const AsyncAdmTaxSchedule = () =>
  import (/*webpackChunkName: "AsyncTaxSchedule" */"@/views/AdmTaxSchedule")
const AsyncSaleOrderSetup = () =>
  import (/*webpackChunkName: "AsyncTaxSchedule" */"@/views/SaleOrderSetup")
const AsyncReports = () =>
  import (/* webpackChunkName: "Reports" */"@/views/Reports")
const AsyncSalePromotion = () =>
  import(/* webpackChunkName: "sale promotion" */"@/views/SalePromotion")
const AsyncCustomerTypeMaster = () =>
  import(/* webpackChunkName: "customer type master" */"@/views/CMCustomerTypeCard")
const AsyncReceiptTransaction = () =>
  import (/* webpackChunkName: "PMReceiptEntry" */"@/components/PMReceiptEntry")
const AsyncPurchaseOrderEntry = () =>
  import (/* webpackChunkName: "PMPurchaseOrderEntry" */"@/components/PMPurchaseOrderEntry")
const AsyncRptSaleHistory = () =>
  import(/* webpackChunkName: "SaleHistoryReport" */"@/components/reports/SaleHistory")
const AsyncRptSaleBackOrderOpen = () =>
  import(/* webpackChunkName: "SaleBackOrderOpen" */"@/components/reports/SaleBackOrderOpen")
const AsyncRptPickingListGeneral = () =>
  import(/* webpackChunkName: "PickingListGeneral" */"@/components/reports/slPickingList/GeneralView")

const AsyncRptProductStocks = () =>
  import(/* webpackChunkName: "SaleHistoryReport" */"@/components/reports/InvProductStocks")
const AsyncIvProductLotMaster = () =>
  import(/* webpackChunkName: "SaleHistoryReport" */"@/components/InvProductLotMaster")
const AsyncOrderDeliveryMethods = () =>
  import(/* webpackChunkName: "menuManagement" */"@/components/SaleOrderDeliveryMethodCard")
const AsyncPurchaseOrderPrint = () =>
  import(/* webpackChunkName: "purchase order print" */"@/components/reports/PMPurchaseOrderPrint")
const AsyncProductLocation = () =>
  import(/* webpackChunkName: "product location" */"@/components/InvProductLocation")
const AsyncUnauthorized = () =>
  import (/* webpackChunkName: "unauthorized"*/ "@/views/Unauthorized")
const AsyncSaleReports = () =>
  import (/* webpackChunkName: "sale reports"*/ "@/views/SaleReports")
const AsyncPurchaseReports = () =>
  import (/* webpackChunkName: "purchase reports"*/ "@/views/PurchaseReports")
const AsyncUserAccount = () =>
  import (/* webpackChunkName: "user account" */ "@/components/layouts/UserAccount")

const AsyncProductEntry = () =>
  import (/* webpackChunkName: "product master" */ "@/views/production/ProductMaster")

const AsyncManufactureOrderEntry = () =>
  import (/* webpackChunkName: "manufacture order entry" */ "@/views/production/ManufactureOrderEntry")

const AsyncProductionOrderEntry = () =>
  import (/* webpackChunkName: "production order entry" */ "@/views/production/ProductionOrderEntry")

const AsyncProductionLabelingOrder = () =>
  import (/* webpackChunkName: "production order entry" */ "@/views/production/ProductionLabelingOrder")

const AsyncProductionReports = () =>
  import (/* webpackChunkName: "production reports" */ "@/views/production/Reports")


let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: AsyncDashboard
    },
    {
      path: "/login",
      name: "login",
      component: AsyncLoginView,
      meta: {
        guest: true,
        public: true,
        onlyWhenLoggedOut: true
      }
    },
    {
      path: "/cuenta",
      name: "UserAccount",
      component: AsyncUserAccount,
      meta: {
        requiresAuth: true,
        viewCode: 0
      }
    },
    {
      path: "/register",
      name: "Register",
      component: AsyncRegisterView
    },
    {
      path: "/principal",
      name: "principal",
      component: AsyncPrincipalView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: AsyncDashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/orden-de-venta",
      name: "sale-order",
      component: AsyncSaleOrder,
      meta: {
        requiresAuth: true,
        viewCode: 2201
      }
    },
    {
      path: "/clientes",
      name: "customers",
      component: AsyncCustomerManagement,
      meta: {
        requiresAuth: true,
        viewCode: 2001
      }
    },
    {
      path: "/cliente/tarjeta/tipos-de-cliente",
      name: "customerType",
      component: AsyncCustomerTypeMaster,
      meta: {
        requiresAuth: true,
        viewCode: 2002
      }
    },
    {
      path: "/proveedores",
      name: "vendors",
      component: AsyncPurchaseManagement,
      meta: {
        requiresAuth: true,
        viewCode: 3001
      }
    },
    {
      path: "/transaccion-de-compra",
      name: "receiptTransaction",
      component: AsyncReceiptTransaction,
      meta: {
        requiresAuth: true,
        viewCode: 3202
      }
    },
    {
      path: "/orden-de-compra",
      name: "purchaseOrderEntry",
      component: AsyncPurchaseOrderEntry,
      meta: {
        requiresAuth: true,
        viewCode: 3201
      }
    },
    {
      path: "/compras/reportes",
      component: AsyncPurchaseReports,
      meta: {
        requiresAuth: true,
        viewCode: 0
      }
    },
    {
      path: "/ventas/reportes/",
      name: "SaleReports",
      component: AsyncSaleReports,
      meta: {
        requiresAuth: true,
        viewCode: 0
      }
    },
    {
      path: "/ventas/reportes/pedidos-y-faltantes",
      component: AsyncRptSaleBackOrderOpen,
      name: "SaleRptBackOrderOpen",
      meta: {
        requiresAuth: true,
        viewCode: 0
      }
    },
    {
      path: "/ventas/reportes/picking-list",
      component: AsyncRptPickingListGeneral,
      name: "SalePickingListGeneral",
      meta: {
        requiresAuth: true,
        viewCode: 0
      }
    },
    {
      path: '/reportes/ventas/historico',
      component: AsyncRptSaleHistory
    },
    {
      path: '/reportes/ventas/pedidos-en-espera',
      component: AsyncRptSaleBackOrderOpen
    },


    // {
    //   path: "/inventario/",
    //   name: "1000",
    //   component: AsyncInventory,
    // },
    {
      path: "/inventario/reportes",
      component: AsyncInventoryReports,
      meta: {
        requiresAuth: true,
        viewCode: 1001
      }
    },
    {
      path: "/inventario",
      name: "1000",
      component: AsyncInventory,
      children: [
        {
          path: ':productCode',
          name: 'Product master',
          component: AsyncInventory,
          viewCode: 1001
        },

      ],
      meta: {
        requiresAuth: true,
        viewCode: 1001
      }
    },

    {
      path: "/inventario/:productId/:locationCode/consulta/lotes",
      name: "lot-inquiry",
      component: AsyncIvProductLotMaster,
      meta: {
        requiresAuth: true,
        viewCode: 0
      },
    },
    {
      path: "/inventario/consulta/stock",
      name: "product-stocks",
      component: AsyncRptProductStocks,
      meta: {
        requiresAuth: true,
        viewCode: 0
      },
    },
    // {
    //   path: "/inventario/report/:productId/",
    //   name: "productInquiry",
    //   component: AsyncInventory,
    //   meta: {
    //     requiresAuth: true,
    //     viewCode: 1001
    //   },
    //   children: [
    //     {
    //       path:
    //     }
    //   ]
    // },
    {
      path: "/transferencia-inventario",
      name: "inventoryTransfer",
      component: AsyncInvTransferEntry,
      meta: {
        requiresAuth: true,
        viewCode: 1201
      }
    },
    {
      path: "/ajuste-inventario",
      name: "inventoryAdjustment",
      component: AsyncInvAdjustmentEntry,
      meta: {
        requiresAuth: true,
        viewCode: 1202
      }
    },
    {
      path: "/codigos-de-retencion",
      name: "reasonCategory",
      component: AsyncReasonCategory,
      meta: {
        requiresAuth: true,
        viewCode: 1009
      }
    },

    {
      path: "/administracion-de-usuario",
      name: "userManagement",
      component: AsyncUserManagement,
      meta: {
        requiresAuth: true,
        viewCode: 4002
      }
    },
    {
      path: "/tasa-de-cambio",
      name: "rateExchangeManagement",
      component: AsyncAdmRateExchange,
      meta: {
        requiresAuth: true,
        viewCode: 4001
      }
    },
    {
      path: "/impuestos",
      name: "taxMaster",
      component: AsyncAdmTaxMaster,
      meta: {
        requiresAuth: true,
        viewCode: 2106
      }
    },
    {
      path: "/Plan-de-impuestos",
      name: "taxSchedule",
      component: AsyncAdmTaxSchedule,
      meta: {
        requiresAuth: true,
        viewCode: 2105
      }
    },
    {
      path: "/metodos-de-pago",
      name: "PaymentMethod",
      component: AsyncPaymentMethod,
      meta: {
        requiresAuth: true,
        viewCode: 2104
      }
    },
    {
      path: "/ventas/configuracion/metodos-de-entrega",
      name: "saleOrderDeliveryMethod",
      component: AsyncOrderDeliveryMethods,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/ventas/vendedores",
      name: "salePerson",
      component: AsyncSalePerson,
      meta: {
        requiresAuth: true,
        viewCode: 2002
      }
    },
    {
      //
      path: "/ventas/promociones",
      name: "salePromotion",
      component: AsyncSalePromotion,
      meta: {
        requiresAuth: true,
        viewCode: 2003
      }
    },
    {
      path: "/ventas/configuracion/codigos-de-documento",
      name: "saleOrderSetup",
      component: AsyncSaleOrderSetup,
      meta: {
        requiresAuth: true,
        viewCode: 2103
      }
    },
    {
      path: "/componentes",
      name: "ProductEntry",
      component: AsyncProductEntry,
      meta: {
        requiresAuth: true,
        viewCode: 5001
      }
    },
    {
      path: "/orden-de-fabricacion",
      name: "manufactureOrderEntry",
      component: AsyncManufactureOrderEntry,
      meta: {
        requiresAuth: true,
        viewCode: 5201
      }
    },
    {
      path: "/orden-de-produccion",
      name: "productionOrderEntry",
      component: AsyncProductionOrderEntry,
      meta: {
        requiresAuth: true,
        viewCode: 5202
      }
    },
    {
      path: "/consumo-de-etiquetas",
      name: "productionLabelingEntry",
      component: AsyncProductionLabelingOrder,
      meta: {
        requiresAuth: true,
        viewCode: 5203
      }
    },
    {
      path: "/produccion/reportes",
      name: "ProductionReports",
      component: AsyncProductionReports,
      meta: {
        requiresAuth: true,
        viewCode: 0
      }
    },
    {
      // AsyncMenu
      path: "/no-autorizado",
      component: AsyncUnauthorized,
      meta: {
        requiresAuth: true,
        guest: true,
        public: true,
      }
    },
    {
      path: "*",
      component: AsyncPageNotFound
    }
  ]
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public);
  const viewCode = to.meta.viewCode
  const routeAccess = store.getters['auth/hasUIPermission'](viewCode)
  const onlyWhenLoggedOut = to.matched.some(
    record => record.meta.onlyWhenLoggedOut
  );
  const loggedIn = !!TokenService.getToken();

  // if (!isPublic && !loggedIn ) {
  //   return next({
  //     path: "/login",
  //     //query: { redirect: to.fullPath } // Store the full path to redirect the user to after login
  //   });
  // }

  if (!routeAccess) {
    return next({
      path: "/no-autorizado"
    })
  }

  // // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next("/dashboard");
  }
  next();

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js